import React from 'react'
import ListPage from '../../components/ListPage';
import Footer from '../../components/Footer'
const Facilities=()=> {

    const ListContent=["Library Spread Over Two Floor ",
        "Stack Area ",
        "Reference Section ",
        "Periodicals, Newspaper and Magazine Section ",
        "Reading Hall ",
        "State of the Art Digital Library  ",
        "Students Discussion Rooms ",
        "Faculty Discussion Rooms "
        ]
  return (
    <div>
       <ListPage
       Title='Facilities'
       ListContent={ListContent}
       
       />
       <Footer/>
    </div>
  )
}
export default Facilities